import {
  AreaTypeEnum,
  DropDownCategoryEnumModel,
  ICommonDataModel,
  ICustomUserDataModel,
  ReferrerTypeEnumModel,
} from "../../../types/types";
import {
  DeleteCategoryVariableHttpRequest,
  DropDownCategoryEnum,
  DuplicateResolutionType,
  HttpValidationProblemDetails,
  ReferrerTypeEnum,
  ResolveDuplicateCandidateRequest,
  UpdateCategoryVariableHttpRequest,
  UpsertUserAreaRequest,
  ValidationProblemDetails,
} from "../../repsaApi";
import api from "./commonApi";
import {
  commonDataError,
  commonDataLoading,
  commonDataLoaded,
  customUserDataLoading,
  customUserDataLoaded,
  customUserDataError,
  addCategoryVariablePending,
  addCategoryVariableFulfilled,
  addCategoryVariableRejected,
  deleteCategoryVariablePending,
  deleteCategoryVariableFulfilled,
  updateCategoryVariablePending,
  updateCategoryVariableFulfilled,
  updateCategoryVariableRejected,
  deleteCategoryVariableRejected,
  hideCategoryVariablePending,
  hideCategoryVariableFulfilled,
  hideCategoryVariableRejected,
  updateAreaTypePreferencePending,
  updateAreaTypePreferenceFulfilled,
  updateAreaTypePreferenceRejected,
  duplicateCandidatesLoading,
  duplicateCandidatesLoaded,
  duplicateCandidatesError,
  resolveDuplicateCandidatePending,
  resolveDuplicateCandidateFulfilled,
  resolveDuplicateCandidateRejected,
} from "./commonStateActions";

/*
 dispatch(
          transactionYearsLoaded(
            data.map(
              (item) => ({ ...item, id: item.id } as ITransactionYearModel)
            )
          )
        ),
*/
export function getCommonData() {
  return function (dispatch: any) {
    dispatch(commonDataLoading());
    api.getCommonData().then(
      (data: ICommonDataModel) => {
        dispatch(
          commonDataLoaded({
            categories: data.categories?.map((item) => ({
              ...item,
              id: item.id,
            })),
          } as ICommonDataModel),
        );
      },
      (error: Error) => dispatch(commonDataError(error.message)),
    );
  };
}

export function getUserCustomData() {
  return function (dispatch: any) {
    dispatch(customUserDataLoading());
    api.getUserCommonData().then(
      (data: ICustomUserDataModel) => {
        dispatch(
          customUserDataLoaded({
            areas: data.areas?.map((item) => ({
              ...item,
              id: item.id,
            })),
            coAgents: data.coAgents?.map((item) => ({
              ...item,
              id: item.id,
            })),
            preferredAreaType: data.preferredAreaType,
            reasons: data.reasons?.map((item) => ({
              ...item,
              id: item.id,
            })),
            sources: data.sources?.map((item) => ({
              ...item,
              id: item.id,
            })),
            specialGroups: data.specialGroups?.map((item) => ({
              ...item,
              id: item.id,
            })),
            specialTags: data.specialTags?.map((item) => ({
              ...item,
              id: item.id,
            })),
            transactionTypes: data.transactionTypes?.map((item) => ({
              ...item,
              id: item.id,
            })),
            referralOutTypes: data.referralOutTypes?.map((item) => ({
              ...item,
              id: item.id,
            })),
          } as ICustomUserDataModel),
        );
      },
      (error: Error) => dispatch(customUserDataError(error.message)),
    );
  };
}

export function searchClients(
  pageIndex: number,
  pageSize: number,
  keyword: string,
) {
  return api.searchClients(pageIndex, pageSize, keyword);
}

export function addCategoryVariable(
  category: DropDownCategoryEnumModel,
  variable: string,
) {
  return function (dispatch: any) {
    dispatch(addCategoryVariablePending(category));
    api
      .addCategoryVariable(
        category as unknown as DropDownCategoryEnum,
        variable,
      )
      .then(
        (data: number | null) => {
          if (data)
            dispatch(addCategoryVariableFulfilled(data, variable, category));
          else {
            dispatch(addCategoryVariableRejected("An error has occurred."));
          }
        },
        (error: Error) => {
          if (
            error instanceof ValidationProblemDetails ||
            error instanceof HttpValidationProblemDetails
          ) {
            const validationErrors = error as
              | ValidationProblemDetails
              | HttpValidationProblemDetails;
            const errorMessage = validationErrors.errors
              ? Object.values(validationErrors.errors).flat().join(", ")
              : "An error has occurred.";
            dispatch(addCategoryVariableRejected(errorMessage));
          } else
            dispatch(addCategoryVariableRejected("An error has occurred."));
        },
      );
  };
}

export function deleteCategoryVariable(
  category: DropDownCategoryEnumModel,
  variableId: number,
) {
  return function (dispatch: any) {
    dispatch(deleteCategoryVariablePending(category));
    const request = new DeleteCategoryVariableHttpRequest();
    request.init({
      dropDownCategory: category as unknown as DropDownCategoryEnum,
      id: variableId,
    });
    api.deleteCategoryVariable(request).then(
      (data: number | null) => {
        if (data && data > 0)
          dispatch(deleteCategoryVariableFulfilled(variableId, category));
        else {
          dispatch(deleteCategoryVariableRejected("An error has occurred."));
        }
      },
      (error: Error) => {
        if (
          error instanceof ValidationProblemDetails ||
          error instanceof HttpValidationProblemDetails
        ) {
          const validationErrors = error as
            | ValidationProblemDetails
            | HttpValidationProblemDetails;
          const errorMessage = validationErrors.errors
            ? Object.values(validationErrors.errors).flat().join(", ")
            : "An error has occurred.";
          dispatch(deleteCategoryVariableRejected(errorMessage));
        } else
          dispatch(deleteCategoryVariableRejected("An error has occurred."));
      },
    );
  };
}
export function updateCategoryVariable(
  category: DropDownCategoryEnumModel,
  variableId: number,
  variable: string,
) {
  return function (dispatch: any) {
    dispatch(updateCategoryVariablePending(category, variableId));

    const request = new UpdateCategoryVariableHttpRequest();
    request.init({
      dropDownCategory: category as unknown as DropDownCategoryEnum,
      id: variableId,
      name: variable,
    });
    api.updateCategoryVariable(request).then(
      (data: number | null) => {
        if (data && data > 0)
          dispatch(
            updateCategoryVariableFulfilled(variableId, variable, category),
          );
        else {
          dispatch(updateCategoryVariableRejected("An error has occurred."));
        }
      },
      (error: Error) => {
        if (
          error instanceof ValidationProblemDetails ||
          error instanceof HttpValidationProblemDetails
        ) {
          const validationErrors = error as
            | ValidationProblemDetails
            | HttpValidationProblemDetails;
          const errorMessage = validationErrors.errors
            ? Object.values(validationErrors.errors).flat().join(", ")
            : "An error has occurred.";
          dispatch(updateCategoryVariableRejected(errorMessage));
        } else
          dispatch(updateCategoryVariableRejected("An error has occurred."));
      },
      // (error: Error) => dispatch(updateCategoryVariableRejected(error.message))
    );
  };
}

export function searchReferrers(
  referrerType: ReferrerTypeEnumModel,
  pageIndex: number,
  pageSize: number,
  keyword: string,
) {
  return api.searchReferrers(
    referrerType as unknown as ReferrerTypeEnum,
    pageIndex,
    pageSize,
    keyword,
  );
}

export function searchContacts(keyword: string) {
  return api.searchContacts(keyword);
}

export function searchVendors(
  pageIndex: number,
  pageSize: number,
  keyword: string,
) {
  return api.searchVendors(pageIndex, pageSize, keyword);
}

export function recalculateFinancialSettings() {
  return api.recalculateFinancialSettings();
}

//hideCategoryVariable
export function showHideCategoryVariable(
  category: DropDownCategoryEnumModel,
  variableId: number,
  hide: boolean,
) {
  return function (dispatch: any) {
    dispatch(hideCategoryVariablePending(category, variableId));
    api
      .switchCategoryVariable(
        category as unknown as DropDownCategoryEnum,
        variableId,
        hide,
      )
      .then(
        (data: number | null) => {
          if (data && data > 0)
            dispatch(
              hideCategoryVariableFulfilled(variableId, "", category, hide),
            );
          else {
            dispatch(hideCategoryVariableRejected("An error has occurred."));
          }
        },
        (error: Error) => {
          if (
            error instanceof ValidationProblemDetails ||
            error instanceof HttpValidationProblemDetails
          ) {
            const validationErrors = error as
              | ValidationProblemDetails
              | HttpValidationProblemDetails;
            const errorMessage = validationErrors.errors
              ? Object.values(validationErrors.errors).flat().join(", ")
              : "An error has occurred.";
            dispatch(hideCategoryVariableRejected(errorMessage));
          } else
            dispatch(hideCategoryVariableRejected("An error has occurred."));
        },
      );
  };
}

export function updateAreaTypePreference(areaType: AreaTypeEnum) {
  return function (dispatch: any) {
    const req = new UpsertUserAreaRequest();
    req.init({
      areaType: areaType as unknown as AreaTypeEnum,
    });
    dispatch(updateAreaTypePreferencePending());
    api.upsertUserArea(req).then(
      () => {
        dispatch(updateAreaTypePreferenceFulfilled(areaType));
      },
      (error: Error) => {
        if (
          error instanceof ValidationProblemDetails ||
          error instanceof HttpValidationProblemDetails
        ) {
          const validationErrors = error as
            | ValidationProblemDetails
            | HttpValidationProblemDetails;
          const errorMessage = validationErrors.errors
            ? Object.values(validationErrors.errors).flat().join(", ")
            : "An error has occurred.";
          dispatch(updateAreaTypePreferenceRejected(errorMessage));
        } else
          dispatch(updateAreaTypePreferenceRejected("An error has occurred."));
      },
    );
  };
}

export function getPendingDuplicateCandidates() {
  return function (dispatch: any) {
    dispatch(duplicateCandidatesLoading());
    api.getPendingDuplicateCandidates().then(
      (data) => dispatch(duplicateCandidatesLoaded(data)),
      (error: Error) => {
        if (
          error instanceof ValidationProblemDetails ||
          error instanceof HttpValidationProblemDetails
        ) {
          const validationErrors = error as
            | ValidationProblemDetails
            | HttpValidationProblemDetails;
          const errorMessage = validationErrors.errors
            ? Object.values(validationErrors.errors).flat().join(", ")
            : "An error has occurred.";
          dispatch(duplicateCandidatesError(errorMessage));
        } else dispatch(duplicateCandidatesError("An error has occurred."));
      },
    );
  };
}

export function resolveDuplicateCandidate(
  duplicateCandidateId: number,
  resolution: DuplicateResolutionType,
  keepSourceEntity?: boolean,
) {
  return function (dispatch: any) {
    dispatch(resolveDuplicateCandidatePending(duplicateCandidateId));

    const request = new ResolveDuplicateCandidateRequest();
    request.init({
      duplicateCandidateId: duplicateCandidateId,
      resolution: resolution,
      keepSourceEntity: keepSourceEntity,
    });

    api.resolveDuplicateCandidate(request).then(
      () => {
        dispatch(resolveDuplicateCandidateFulfilled(duplicateCandidateId));
      },
      (error: Error) => {
        if (
          error instanceof ValidationProblemDetails ||
          error instanceof HttpValidationProblemDetails
        ) {
          const validationErrors = error as
            | ValidationProblemDetails
            | HttpValidationProblemDetails;
          const errorMessage = validationErrors.errors
            ? Object.values(validationErrors.errors).flat().join(", ")
            : "An error has occurred.";
          dispatch(resolveDuplicateCandidateRejected(errorMessage));
        } else
          dispatch(resolveDuplicateCandidateRejected("An error has occurred."));
      },
    );
  };
}
